export const RESET = 'registered/RESET';
export const RESET_LOADINGTRUE = 'registered/RESET_LOADINGTRUE';
export const RESET_LOADINGFALSE = 'registered/RESET_LOADINGFALSE';
